<template>
  <div class="big">
    <div>
      <div class="page_title">用户埋点设置</div>
      <div style="padding:20px">

        <div class="container">
          <div class="searchbox">
            <el-button
              type="primary"
              style="width: 120px; margin-right: 30px"
              icon="el-icon-plus"
              @click="addPoint"
              :disabled="
            module_id_array[0] ? !module_id_array.includes('1024') : false
          "
            >添加事件</el-button>
            <span>事件名称</span>
            <el-input
              v-model="key_name"
              style="width: 200px; margin: 0 10px"
              clearable
              @input="search"
            ></el-input>
            <el-button
              type="info"
              style="background-color: #eceff2; color: #747981"
              @click="search"
            >查询</el-button>
          </div>
          <div style="border: solid 1px #c9cbd6">
            <el-table
              ref="multipleTable"
              :data="tableData"
              tooltip-effect="dark"
              style="width: 100%; min-width: 1000px"
              :header-cell-style="{ background: '#F5F5F5' }"
            >
              <el-table-column
                prop="key_name"
                label="事件名称"
              >
              </el-table-column>
              <el-table-column
                prop="android_buried_point_code"
                label="用户APP-android"
              ></el-table-column>
              <el-table-column
                prop="ios_buried_point_code"
                label="用户APP-ios"
              >
              </el-table-column>
              <el-table-column
                prop="shopapplet_buried_point_code"
                label="商城小程序"
              ></el-table-column>

              <el-table-column
                label="患者小程序"
                prop="applet_buried_point_code"
              >

              </el-table-column>
              <el-table-column label="备注">
                <template slot-scope="scope">
                  <div>{{scope.row.remark}}</div>
                </template>
              </el-table-column>
              <el-table-column
                prop="update_time"
                label="更新时间"
              ></el-table-column>

              <el-table-column label="操作">
                <template slot-scope="scope">
                  <el-button
                    @click="toDetail(scope.row)"
                    type="text"
                    :disabled="
                  module_id_array[0] ? !module_id_array.includes('1025') : false
                "
                  >查看</el-button>
                  <el-button
                    @click="editDia(scope.row)"
                    type="text"
                    :disabled="
                  module_id_array[0] ? !module_id_array.includes('1031') : false
                "
                  >编辑</el-button>

                </template>
              </el-table-column>
            </el-table>
          </div>
          <div>
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="10"
              layout="total, sizes, prev, pager, next, jumper"
              :total="totalNum"
              style="margin:20px 0"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>

    <!-- 添加弹窗 -->
    <el-dialog
      :title="title"
      :visible.sync="add_point"
      width="740px"
      :close-on-click-modal="false"
    >
      <div class="myform">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="140px"
          class="demo-ruleForm"
        >
          <el-form-item
            label="事件名称"
            prop="key_name"
          >
            <el-input
              v-model="ruleForm.key_name"
              maxlength="20"
              style="width: 300px"
              :disabled="disabled"
            ></el-input>
          </el-form-item>
          <div class="title">
            用户APP-android设置
          </div>
          <div class="flex">
            <el-form-item
              label="code"
              :required="ruleForm.android_buried_point_name||ruleForm.android_buried_point_code?true:false"
            >
              <el-input
                v-model="
              ruleForm.android_buried_point_code"
                maxlength="20"
                style="width: 200px"
                :disabled="disabled"
              >
              </el-input>
            </el-form-item>
            <el-form-item
              :required="ruleForm.android_buried_point_name||ruleForm.android_buried_point_code?true:false"
              label="页面名称"
            >
              <el-input
                v-model="ruleForm.android_buried_point_name"
                maxlength="20"
                style="width: 200px"
                :disabled="disabled"
              ></el-input>
            </el-form-item>
          </div>
          <div class="title">
            用户APP-ios设置
          </div>
          <div class="flex">
            <el-form-item
              label="code"
              :required="ruleForm.ios_buried_point_code||ruleForm.ios_buried_point_name?true:false"
            >
              <el-input
                v-model="ruleForm.ios_buried_point_code"
                maxlength="20"
                style="width: 200px"
                :disabled="disabled"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="页面名称"
              :required="ruleForm.ios_buried_point_code||ruleForm.ios_buried_point_name?true:false"
            >
              <el-input
                v-model="ruleForm.ios_buried_point_name"
                maxlength="20"
                style="width: 200px"
                :disabled="disabled"
              ></el-input>
            </el-form-item>
          </div>
          <div class="title">
            商城小程序设置
          </div>
          <div class="flex">
            <el-form-item
              label="code"
              :required="ruleForm.shopapplet_buried_point_code||ruleForm.shopapplet_buried_point_name?true:false"
            >
              <el-input
                v-model="ruleForm.shopapplet_buried_point_code"
                maxlength="20"
                style="width: 200px"
                :disabled="disabled"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="页面名称"
              :required="ruleForm.shopapplet_buried_point_code||ruleForm.shopapplet_buried_point_name?true:false"
            >
              <el-input
                v-model="ruleForm.shopapplet_buried_point_name"
                maxlength="20"
                style="width: 200px"
                :disabled="disabled"
              ></el-input>
            </el-form-item>
          </div>
          <div class="title">
            患者小程序设置
          </div>
          <div class="flex">
            <el-form-item
              label="code"
              :required="ruleForm.applet_buried_point_code||ruleForm.applet_buried_point_name?true:false"
            >
              <el-input
                v-model="ruleForm.applet_buried_point_code"
                maxlength="20"
                style="width: 200px"
                :disabled="disabled"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="页面名称"
              :required="ruleForm.applet_buried_point_code||ruleForm.applet_buried_point_name?true:false"
            >
              <el-input
                v-model="ruleForm.applet_buried_point_name"
                maxlength="20"
                style="width: 200px"
                :disabled="disabled"
              ></el-input>
            </el-form-item>
          </div>

          <el-form-item label="备注">
            <el-input
              v-model="ruleForm.remark"
              style="width: 300px"
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 4}"
              maxlength="100"
              :disabled="disabled"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div style="height: 1px; background-color: #d9dadd; margin-bottom: 14px"></div>
      <div
        style="text-align: center; padding-bottom: 20px"
        v-if="!disabled"
      >
        <span
          slot="footer"
          class="dialog-footer"
        >
          <el-button
            plain
            @click="add_point = false"
            style="width: 92px"
            size="medium"
          >关闭</el-button>
          <el-button
            type="primary"
            @click="submit('ruleForm')"
            style="width: 92px"
            size="medium"
          >保存</el-button>
        </span>
      </div>
    </el-dialog>

  </div>
</template>
<script>
import _ from 'lodash';
import dayjs from 'dayjs';
export default {
  data() {
    return {
      currentPage: 1,
      pagesize: 10,
      totalNum: 0,
      tableData: [],
      title: '添加事件',
      key_name: '',
      doctorPhone: '',
      add_point: false,
      ruleForm: {
        key_name: '',
        ios_buried_point_code: '',
        ios_buried_point_name: '',
        android_buried_point_code: '',
        android_buried_point_name: '',
        shopapplet_buried_point_code: '',
        shopapplet_buried_point_name: '',
        applet_buried_point_code: '',
        applet_buried_point_name: '',
        remark: ''
      },
      rules: {
        key_name: [
          {
            required: true,
            message: '请输入事件名称',
            trigger: 'blur'
          }
        ]
      },
      disabled: false
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
    admin_id() {
      return this.$store.state.login.userInfo.admin_id;
    }
  },
  methods: {
    //获取列表
    getList() {
      let data = {
        page: this.currentPage,
        pageNumber: this.pagesize,
        key_name: this.key_name
      };
      this.axios
        .post('platform/Buried/buriedPointList', data)
        .then((res) => {
          if (res.code == 0) {
            this.tableData = res.data.list.map((item) => {
              item.update_time = dayjs
                .unix(item.update_time)
                .format('YYYY-MM-DD HH:mm');
              return item;
            });
            this.totalNum = res.data.total;
          }
        })
        .catch((err) => {
          this.loading = false;
          console.log(err);
        });
    },
    //每页数据的条数
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //当前第几页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    //搜索
    search() {
      this.currentPage = 1;
      this.getList();
    },
    //添加按钮
    addPoint() {
      this.title = '添加事件';
      this.disabled = false;
      this.ruleForm = {
        key_name: '',
        ios_buried_point_code: '',
        ios_buried_point_name: '',
        android_buried_point_code: '',
        android_buried_point_name: '',
        shopapplet_buried_point_code: '',
        shopapplet_buried_point_name: '',
        applet_buried_point_code: '',
        applet_buried_point_name: '',
        remark: ''
      };
      this.add_point = true;
    },
    //编辑弹窗
    editDia(row) {
      this.title = '编辑事件';
      this.disabled = false;
      this.ruleForm = {
        id: row.id,
        key_name: row.key_name,
        ios_buried_point_code: row.ios_buried_point_code,
        ios_buried_point_name: row.ios_buried_point_name,
        android_buried_point_code: row.android_buried_point_code,
        android_buried_point_name: row.android_buried_point_name,
        shopapplet_buried_point_code: row.shopapplet_buried_point_code,
        shopapplet_buried_point_name: row.shopapplet_buried_point_name,
        applet_buried_point_code: row.applet_buried_point_code,
        applet_buried_point_name: row.applet_buried_point_name,
        remark: row.remark
      };
      this.add_point = true;
    },
    //查看详情
    toDetail(row) {
      this.title = '查看事件';
      this.disabled = true;
      this.ruleForm = {
        key_name: row.key_name,
        ios_buried_point_code: row.ios_buried_point_code,
        ios_buried_point_name: row.ios_buried_point_name,
        android_buried_point_code: row.android_buried_point_code,
        android_buried_point_name: row.android_buried_point_name,
        shopapplet_buried_point_code: row.shopapplet_buried_point_code,
        shopapplet_buried_point_name: row.shopapplet_buried_point_name,
        applet_buried_point_code: row.applet_buried_point_code,
        applet_buried_point_name: row.applet_buried_point_name,
        remark: row.remark
      };
      this.add_point = true;
    },
    //添加医生
    submit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = this.ruleForm;
          if (
            (data.ios_buried_point_code && !data.ios_buried_point_name) ||
            (data.ios_buried_point_name && !data.ios_buried_point_code)
          ) {
            this.$message.error('请完善ios埋点事件');
            return false;
          }

          if (
            (data.shopapplet_buried_point_code &&
              !data.shopapplet_buried_point_name) ||
            (data.shopapplet_buried_point_name &&
              !data.shopapplet_buried_point_code)
          ) {
            this.$message.error('请完善商城小程序埋点事件');
            return false;
          }

          if (
            (data.android_buried_point_code &&
              !data.android_buried_point_name) ||
            (data.android_buried_point_name && !data.android_buried_point_code)
          ) {
            this.$message.error('请完善android埋点事件');
            return false;
          }

          if (
            (data.applet_buried_point_code && !data.applet_buried_point_name) ||
            (data.applet_buried_point_name && !data.applet_buried_point_code)
          ) {
            this.$message.error('请完善患者小程序埋点事件');
            return false;
          }
          let url = 'platform/Buried/saveBuriedPoint';
          if (data.id) {
            url = 'platform/Buried/updateBuriedPoint';
          }
          this.axios.post(url, data).then((res) => {
            if (res.code == 0) {
              this.$message.success('保存成功！');
              this.add_point = false;
              this.getList();
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  },
  created() {
    this.getList();
  }
};
</script>

<style lang="scss" scoped>
.container {
  padding: 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
.searchbox {
  display: flex;
  margin-bottom: 20px;
  align-items: center;
}

.myform {
  text-align: left;
  padding: 20px 0 0 20px;
  margin-bottom: 20px;
  box-sizing: border-box;
  .title {
    margin-bottom: 10px;
    width: 140px;
    text-align: right;
  }
}
.content {
  padding: 20px;
  text-align: left;
  .box {
    background: #f5f5f5;
    margin-top: 8px;
    padding: 10px;
  }
  .green {
    color: #669961;
    font-weight: 700;
    margin-top: 20px;
  }
  .title {
    font-weight: 700;
    margin-bottom: 6px;
  }
  .item {
    margin-bottom: 14px;
  }
  .pricebox {
    display: flex;
    align-items: center;
    padding: 15px 0;
    box-sizing: border-box;
    .priceitem {
      text-align: center;
      padding: 0 20px;
      border-right: solid 1px #d6d6d6;
    }
    .priceitem:before {
      content: '';
    }
    .gray {
      font-size: 12px;
      color: #747981;
      display: inline-block;
      width: 60px;
    }
    .num {
      font-size: 18px;
      font-weight: 600;
    }
    .red {
      color: #f24e33;
    }
  }
}
</style>